import { Link } from 'react-router-dom';

/**
 * Gmail bills-inbox connection page. The Cloud Function pollBillsInbox is
 * already deployed — this page just documents the setup steps and gives a
 * link to the dedicated mailbox once it exists.
 */
export function GmailBills() {
  return (
    <div className="mx-auto w-full max-w-4xl space-y-6 px-6 py-6">
      <header>
        <div className="text-[10px] uppercase tracking-wider text-stone-400">Integration</div>
        <h1 className="text-2xl font-semibold text-stone-800">Gmail — bills inbox</h1>
        <p className="mt-1 text-sm text-stone-500">
          Forward every bill to a dedicated Gmail; the SFP backend OCRs, classifies, and routes
          them to the Bills queue automatically.
        </p>
      </header>

      <div className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm">
        <div className="text-[10px] uppercase tracking-wider text-amber-700">Setup required</div>
        <h2 className="mt-1 text-sm font-semibold text-stone-800">Three steps</h2>
        <ol className="mt-3 list-decimal space-y-2 pl-5 text-xs leading-relaxed text-stone-700">
          <li>
            Create a dedicated Gmail (e.g. <code>sfp.bills@gmail.com</code>) or alias on your
            Workspace domain. Use a strong password + 2FA.
          </li>
          <li>
            Forward bills from your personal inbox to it. For known billers, set the forwarding
            automatically; for one-offs, forward manually.
          </li>
          <li>
            Run <code>npm --workspace scripts run setup:gmail</code> once to register the Gmail
            API watch + OAuth. After that, every new email triggers <code>pollBillsInbox</code>,
            which writes a <code>bills/</code> row visible in <Link to="/bills" className="text-[#BF5700] hover:underline">/bills</Link>.
          </li>
        </ol>
      </div>

      <div className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm">
        <h2 className="text-sm font-semibold text-stone-800">Open the inbox</h2>
        <p className="mt-1 text-xs text-stone-600">
          Convenient link to whichever mailbox you wire up.
        </p>
        <a
          href="https://mail.google.com"
          target="_blank"
          rel="noreferrer"
          className="mt-3 inline-block rounded border border-stone-300 px-3 py-1.5 text-xs font-medium text-stone-700 hover:bg-stone-50"
        >
          Open Gmail ↗
        </a>
      </div>

      <Link to="/settings" className="block text-xs text-[#BF5700] hover:underline">
        ← Back to settings
      </Link>
    </div>
  );
}
